<template>
  <van-popup
    v-model="visibleConfirm"
    closeable
    position="bottom"
    @close="close"
    :style="{ height: '100%', zIndex: '999999' }"
  >
    <!-- <head-nav-bar title="确认下单" :fixed="true" :arrow-left="false" /> -->
    <div class="mt-header-nav confirm-box">
      <cell-box style="padding: 0.3rem 0;" :column="2">
        <cell-item label="联系人：" :value="orderData.Contact" />
        <cell-item label="就餐人数：" :value="orderData.PersonCount" />
        <cell-item
          label="会员卡："
          v-if="orderData.MemberName"
          :value="orderData.MemberName"
        />
        <cell-item label="电话：" :value="orderData.Phone" />
        <cell-item
          label="桌台："
          style="gridColumn:span 2;"
          :value="orderData.DishTables && orderData.DishTables[0].TableName"
        />
      </cell-box>
      <h3 class="selected-title">
        已选菜品
      </h3>
      <div class="select-foods detail-select-table">
        <template v-for="item in orderFoodList">
          <van-card :key="item.DishId" v-if="Number(item.Quantity) > 0">
            <template #price>
              <div style="color:#555">
                <van-tag
                  type="success"
                  round
                  v-if="orderData.IsMember && item.MemberUnitPrice != null"
                  >会</van-tag
                >
                &yen;{{
                  orderData.IsMember && item.MemberUnitPrice != null
                    ? item.MemberUnitPrice
                    : item.UnitPrice
                }}
                x {{ item.Quantity }}
              </div>
            </template>
            <template #title>
              <div class="food-title">
                <span>
                  {{ item.DishName }}/<em>{{ item.UnitName }}</em>
                  <span
                    v-if="item.PracticeDesc || item.CookingMethodDesc"
                    class="method-txt"
                  >
                    「做法」{{ item.PracticeDesc }}{{ item.CookingMethodDesc }}
                  </span>
                </span>
                <span v-if="item.IsPack">
                  <van-tag color="#f60" @click="openPack(item)"
                    >套餐&nbsp;<van-icon
                      :name="
                        openKeys.includes(item.DishId) ||
                        openKeys.includes(item.Id)
                          ? 'arrow-up'
                          : 'arrow-down'
                      "
                  /></van-tag>
                </span>
              </div>
            </template>
            <template #num>
              <span style="color:#f00"> &yen;{{ item.TotalPrice }}</span>
            </template>
            <template v-if="item.IsPack" #footer>
              <ul
                class="pack-detail"
                :class="{
                  'pack-detail-open':
                    openKeys.includes(item.DishId) ||
                    openKeys.includes(item.Id),
                }"
              >
                <li v-for="pack in item.PackDetails" :key="pack.Id">
                  {{ pack.Name }} x {{ pack.Quantity }}
                </li>
              </ul>
            </template>
          </van-card>
        </template>
      </div>
      <van-goods-action class="confirm-pop">
        <div slot="default" class="summary-info" style="width:60%">
          <span>
            <van-icon name="shopping-cart-o" />总数：<em
              >{{ total ? total.Quantity : 0 }}
            </em></span
          >
          <span>
            <van-icon name="balance-o" />总计：<em
              >&yen; {{ total ? total.TotalPrice : 0 }}</em
            >
          </span>
        </div>
        <van-goods-action-button
          type="danger"
          text="确认下单"
          :loading="loading"
          @click="beforeSubmit"
        />
      </van-goods-action>
    </div>
  </van-popup>
</template>

<script>
import "./restarant.less";
// import { accAdd } from "@/utils/common";
import { CellBox, CellItem } from "@/components/cell";
import restaurantApi from "@/api/restaurant.js";
// import { mapState } from "vuex";
import {
  Cell,
  CellGroup,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Card,
  Tag,
  Popup,
  Dialog,
  Icon,
  Notify,
} from "vant";
// import { ls } from "@/utils/cache.js";
export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderFoodList: [],
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      orderData: {},
      orderId: "",
      openKeys: [],
      visibleConfirm: false,
      currentTable: {},
      loading: false,
    };
  },
  // computed: {
  //   ...mapState({
  //     restaruantInfo: state => state.user.restaruantInfo
  //   })
  // },
  created() {},
  methods: {
    show(orderData, orderFoodList, total) {
      this.visibleConfirm = true;
      this.orderData = orderData;
      this.orderFoodList = orderFoodList;
      if (this.$route.query.tableId) {
        this.currentTable = this.orderData.DishTables.find(
          item => item.TableId === this.$route.query.tableId,
        );
      } else {
        this.currentTable = this.orderData.DishTables[0];
      }
      this.total = total;
    },
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    // init() {
    //   let total = 0,
    //     num = 0;
    //   this.orderFoodList.forEach(item => {
    //     num = accAdd(num, item.Quantity);
    //     total = accAdd(total, item.TotalPrice);
    //   });

    //   this.total.Quantity = num;
    //   this.total.TotalPrice = total;
    // },
    close() {
      this.$emit("close");
    },
    beforeSubmit() {
      const _this = this;
      Dialog.confirm({
        title: "确定下单吗？",
      }).then(() => {
        _this.onSubmit();
      });
      // if (this.loading) {
      //   return false;
      // }
      // this.loading = true;
      // setTimeout(() => {
      //   this.onSubmit();
      // }, 500);
    },
    onSubmit() {
      const { orderData, orderFoodList } = this;
      let json = {
        OrderId: orderData.Id,
        IsPrint: false,
        Tables: [],
      };
      const list = orderFoodList.map(item => {
        return {
          ...item,
          AccountItemId: item.DishId,
          AccountItemName: item.DishName,
        };
      });
      if (this.$route.query.tableId || orderData.DishTables.length === 1) {
        // 单台点菜
        json.Tables = [
          {
            TableId: this.currentTable.TableId,
            TableName: this.currentTable.TableName,
            Dishes: list,
          },
        ];
      } else if (orderData.DishTables.length) {
        // 多台
        for (let i = 0; i < orderData.DishTables.length; i++) {
          const item = orderData.DishTables[i];
          if (item.OrderStatus != 2) {
            json.Tables.push({
              TableId: item.TableId,
              TableName: item.TableName,
              Dishes: list,
            });
          }
        }
      }
      //点菜
      const that = this;
      that.loading = true;
      restaurantApi
        .orderDish(json)
        .then(() => {
          Notify({ type: "success", message: "下单成功" });
          setTimeout(() => {
            that.$router.push({
              name: "restarantManageIndex",
            });
            // setTimeout(() => {
            //   this.loading = false;
            //   that.visibleConfirm = false;
            // }, 1000);
          }, 500);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 230px);
  padding-bottom: 0;
}
// .confirm-pop {
//   z-index: 99999;
// }
</style>
